<style scoped>
.card {
  background: #fffdfd;
  border-radius: 16px;
  padding: 1.5rem 0.2rem;
  max-width: 400px;
  max-height: 600px;
  font-family: 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.topo {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.produto-img {
  width: 90px;
}

.selo-img {
  height: 120px;
}

.titulo {
  height: 100px;
}

.titulo,
.product-name {
  font-size: 1rem;
  font-weight: bold;
  color: #0a0891;
}

.titulo span {
  margin-bottom: 5px;
}

.titulo-tecnico {
  font-size: 0.7rem;
  font-weight: normal;
  color: #000000;
}

.codigo {
  font-weight: normal;
  font-size: 0.85rem;
  color: #444;
}

.especificacoes {
  display: flex;
  gap: 0.2rem;
  align-items: center;
  font-size: 0.9rem;
  color: #0c2238;
  margin: 0.5rem 0;
}

.icone {
  display: inline-flex;
  align-items: center;
}

.detalhes {
  color: #555;
  font-size: 0.85rem;
}

.badge {
  background: #2e89ee;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.85rem;
  width: 100%;
}

.precos {
  margin-top: 0;
  font-size: 1.8rem;
  font-weight: bold;
  color: #365db5;
  text-align: center;
}

.parcelado {
  display: block;
  font-size: 0.8rem;
  color: #900;
  font-weight: 500;
}

.preco-parcelado {
  font-size: 1.15rem;
}

.estoque {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #2d7d46;
  font-weight: 600;
}

.comprar:hover {
  background: #006e54;
}

.destrave-seu-negocio {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}
</style>
<template>
  <div class="a product-style-2 equal-elem product-box-size">
    <div class="card" v-if="product.showActions && product.isLogged">
      <div class="topo">
        <a :href="product.url" :title="product.name" target="_blank">
          <figure class="product-box-image">
            <img async :src="product.img" :alt="product.name" class="product-image-size" />
          </figure>
          <span v-for="(selo, index) in product.productSelos" :key="index">
            <img
              async
              :srcset="selo.Selo"
              :src="selo.Selo"
              :alt="selo.Campanha"
              :title="selo.Campanha"
              class="img-slide"
              v-bind:style="
                selo.Position == 'botton'
                  ? 'position:absolute;left:10px;max-width:50px;bottom:0;'
                  : 'position:absolute;left:10px;max-width:50px;top:20px;bottom:0;'
              "
            />
          </span>
        </a>
      </div>

      <div class="descricao">
        <h1 class="titulo">
          <span class="codigo">Código: {{ product.code }}</span>
          <a :href="product.url" class="product-name" target="_blank">
            <span>{{ product.name }} ({{ product.code }})</span>
          </a>
        </h1>

        <p class="titulo-tecnico">
          {{ product.description }}
        </p>

        <p class="especificacoes" v-if="product.gerador">
          <span class="icone">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M13 2L3 14h9l-1 8L21 10h-9l1-8z" /></svg>
          </span>
          Potência: {{ product.potenciaGerador }}

          <span class="icone">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 2L15 8H9l3-6zM9 16h6l-3 6zM4 12h16" />
            </svg>
          </span>
          Inversor: {{ product.potenciaInversor }} {{ product.tensao }} {{ product.fase }}
        </p>
      </div>

      <div class="info-preco">
        <div class="badge">
          <svg width="18" height="18" fill="white" viewBox="0 0 24 24">
            <path d="M2 12L12 2H22V12L12 22L2 12Z" fill="white" />
            <circle cx="17" cy="7" r="1.5" fill="#2e89ee" />
          </svg>
          DESCONTO EXCLUSIVO À VISTA
        </div>

        <div class="precos">
          <span class="preco">{{ formatPrice(product.price) }}</span>
        </div>

        <div class="destrave-seu-negocio">
          <img src="/assets/images/selo-destrave-o-seu-negocio.png" alt="ícone" width="70" height="70" style="margin-right: 8px; max-width: 70px" />
          <span class="parcelado"
            >Ou com entrada de 30%<br />e até mais <b class="parcelas">9x</b> semanais
            <span class="parcelado preco-parcelado">de {{ formatPrice(product.valorParcela) }}</span></span
          >
        </div>
      </div>

      <div v-if="product.price > 0" class="actions">
        <a
          @mouseover="getPrecoComSt"
          v-if="product.isLogged && product.price > 0"
          class="col-md-12 btn-light btn btn-xs"
          style="padding-left: 0px; margin-bottom: 4px; width: 100%"
        >
          {{ precoComSt }}
        </a>
        <a
          @mouseover="getDisponibilidade"
          v-if="product.isLogged && product.price > 0"
          class="col-md-12 btn-light btn btn-xs"
          style="margin-top: 0; padding-left: 0; width: 100%"
          v-html="disponibilidade"
        >
        </a>
      </div>

      <div style="align-items: center; gap: 12px; margin-top: 10px">
        <div v-if="isCarousel">
          <DetailsButton :url="product.url" />
        </div>
        <div v-else>
          <BuyButton :product="product" :simpleButton="true" />
        </div>
      </div>
    </div>

    <!-- <div class="product">
      <div v-if="product.showActions && product.isLogged" class="a product-style-2 equal-elem product-box-size">
        <div>
          <div class="product-thumnail align-center">
            <a :href="product.url" :title="product.name" target="_blank">
              <figure class="product-box-image">
                <img async :src="product.img" :alt="product.name" class="product-image-size" />
              </figure>
              <span v-for="(selo, index) in product.productSelos" :key="index">
                <img
                  async
                  :srcset="selo.Selo"
                  :src="selo.Selo"
                  :alt="selo.Campanha"
                  :title="selo.Campanha"
                  class="img-slide"
                  v-bind:style="
                    selo.Position == 'botton'
                      ? 'position:absolute;left:10px;max-width:50px;bottom:0;'
                      : 'position:absolute;left:10px;max-width:50px;top:20px;bottom:0;'
                  "
                />
              </span>
            </a>
          </div>
          <div class="product-info row align-center">
            <div class="">
              <span class="product-code" style="float: left">Código: {{ product.code }} </span>
            </div>

            <div class="">
              <h3>
                <a :href="product.url" class="product-name" target="_blank">
                  <span>{{ product.name }} ({{ product.code }})</span>
                </a>
              </h3>
            </div>

            <div class="product-potencia row align-center" v-if="product.gerador">
              <span class="product-potencia-label"
                ><span class="icon-circle"><i class="fa fa-solid fa-bolt"></i></span>Potência: {{ product.potenciaGerador }}
              </span>
              <span class="product-potencia-label">Inversor: {{ product.potenciaInversor }} </span>
              <span class="product-potencia-label"> {{ product.tensao }} {{ product.fase }} </span>
            </div>

            <div class="wrap-price" style="margin-bottom: 0px; text-align: left">
              <div class="product-off-card-container">
                <div class="product-off-card">
                  <div class="product-off-card-tag">
                    <i class="fa fa-tag"></i>
                  </div>
                  <div class="product-off-card-text">
                    <div>COM DESCONTO</div>
                    <div>EXCLUSIVO</div>
                  </div>
                </div>
                <div class="product-off-card-price">{{ formatPrice(product.price) }}</div>
              </div>
              <div class="col-md-6">
                <div style="font-size: 18px; color: red; font-weight: bold; line-height: 30px">{{ formatPrice(product.valorParcela) }}</div>
                <div style="font-size: 12px; color: black; font-weight: bold; margin-top: -4px">Em até 9x Semanais</div>
              </div>
            </div>
          </div>

            <div class="product-suframa row align-center" v-if="product.suframa">
              <span class="product-suframa-label"> Desconto suframa será aplicado no carrinho </span>
            </div>
            <div style="height: auto">
              <del v-if="product.isLogged && product.promotionalPrice > 0"></del>
              <br v-if="product.isLogged && product.promotionalPrice > 0" />
              <span v-if="!product.isLogged && product.price > 0" class="product-price" style="height: 25px">{{ product.price }}</span>
              <span v-if="!product.isLogged && product.price == 0" class="product-price" style="height: 25px">Produto Indisponível</span>

            <br />
            <PaymentOptionsModal
              :ref="'modalPagamento_' + product.code"
              :preco="product.price"
              :codigoProduto="parseInt(product.code.split('-')[0])"
              :mostrarBotaoInterno="false"
              :isCarousel="isCarousel"
              :url="product.url"
            />

              <a
                @mouseover="getPrecoComSt"
                v-if="product.isLogged && product.price > 0"
                class="col-md-12 btn-light btn btn-xs"
                style="padding-left: 0px; margin-bottom: 4px; width: 100%"
              >
                {{ precoComSt }}
              </a>
              <a
                @mouseover="getDisponibilidade"
                v-if="product.isLogged && product.price > 0"
                class="col-md-12 btn-light btn btn-xs"
                style="margin-top: 0px; padding-left: 0px; width: 100%"
                v-html="disponibilidade"
              >
              </a>
              <span v-if="!product.isLogged" class="product-suggested-price tag tag-red">Preço sugerido ao consumidor final</span>
            </div>
          </div>
          <div v-if="product.showActions && product.isLogged && product.price > 0" class="actions">
            <div v-if="isCarousel">
              <DetailsButton :url="product.url" />
            </div>
            <div v-else>
              <BuyButton :product="product" />
            </div>
          </div>
        </div>
      </div>

      <div v-else class="product-style-2 equal-elem">
        <div>
          <div class="product-thumnail align-center">
            <a :href="product.url" :title="product.name" target="_blank">
              <figure class="product-box-image">
                <img async :src="product.img" :alt="product.name" class="product-image-size col-md-12" />
              </figure>

              <span v-for="(selo, index) in product.productSelos" :key="index">
                <img
                  async
                  :srcset="selo.Selo"
                  :src="selo.Selo"
                  :alt="selo.Campanha"
                  :title="selo.Campanha"
                  class="img-slide"
                  v-bind:style="
                    selo.Position == 'botton'
                      ? 'position:absolute;left:10px;max-width:50px;bottom:0;'
                      : 'position:absolute;left:10px;max-width:50px;top:20px;bottom:0;'
                  "
                />
              </span>
            </a>
          </div>
          <div class="product-info align-center">
            <div>
              <div style="min-height: 20px">
                <span class="product-code" style="float: left">Código: {{ product.code }} </span>
              </div>
            </div>

            <div>
              <div style="min-height: 80px">
                <h3>
                  <a :href="product.url" class="product-name" target="_blank"
                    ><span>{{ product.name }} ({{ product.code }})</span></a
                  >
                </h3>
              </div>
            </div>

            <div>
              <div style="min-height: 80px">
                <p class="product-description">{{ product.description }}</p>
              </div>
            </div>

          <div>
            <div class="wrap-price" style="height: 25px">
              <del v-if="product.isLogged && product.promotionalPrice > 0 && product.promotionalPrice != product.price">
                ><p class="product-price">De: {{ formatPrice(product.promotionalPrice) }}</p></del
              >
              <br v-if="product.isLogged && product.promotionalPrice > 0" />
              <span v-if="!product.isLogged" class="product-price" style="color: #0066a1; line-height: 25px">{{ formatPrice(product.price) }}</span>
              <span v-if="product.isLogged" style="color: #0066a1; line-height: 25px" class="product-price">{{ formatPrice(product.price) }}</span>
              <br />
              <a
                @mouseover="getPrecoComSt"
                v-if="product.isLogged"
                class="col-md-12 btn-light btn btn-xs"
                style="padding: 0px; margin-bottom: 4px; width: 100%"
              >
                {{ precoComSt }}
              </a>
              <a
                @mouseover="getDisponibilidade"
                v-if="product.isLogged"
                class="col-md-12 btn-light btn btn-xs"
                style="margin-top: 0px; padding: 0px; width: 100%"
                v-html="disponibilidade"
              >
              </a>
            </div>

              <div v-if="product.showActions" class="actions">
                <BuyButton :product="product" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import BuyButton from './BuyButton.vue'
import DetailsButton from './DetailsButton.vue'
import PaymentOptionsModal from '../PaymentOptionsModal.vue'

export default {
  name: 'Product',
  data() {
    return {
      precoComSt: 'Consultar valor com ST',
      disponibilidade: 'Consultar Disponibilidade',
      countDisponibilidade: 0,
      countPrecoComST: 0,
      isCarousel: false,
    }
  },
  props: ['product', 'carousel'],
  components: {
    BuyButton,
    DetailsButton,
    PaymentOptionsModal,
  },
  created: function () {
    this.isCarousel = this.carousel
  },
  methods: {
    getList: function () {
      this.$parent.$parent.getList()
    },
    openModal(produto) {
      this.$set(this, 'currentProduct', produto)
      this.$refs['modalPagamento_' + produto.code][0].openModalExternamente()
    },
    consultarFormasPagamento() {
      this.$refs.modalPagamento.openModalExternamente()
    },
    formatPrice: function (price) {
      if (price > 0) {
        return (
          'R$ ' +
          price.toLocaleString('pt-BR', {
            // Ajustando casas decimais
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        )
      } else {
        return 'Produto Indisponível'
      }
    },
    getDisponibilidade: function (event) {
      if (this.countDisponibilidade == 0) {
        let xhr = new XMLHttpRequest()

        xhr.open('POST', this.$apiUrl + 'Produto.svc/getsaldo')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.onload = () => {
          if (xhr.status == 200) {
            this.countDisponibilidade++
            let saldo = JSON.parse(xhr.responseText)

            if (saldo === 'DISPONÍVEL') {
              this.disponibilidade = ': Disponível em estoque'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-available')
            } else if (saldo === 'INDISPONÍVEL') {
              this.disponibilidade = ': Indisponível em estoque'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            } else if (saldo === 'SOB ENCOMENDA') {
              this.disponibilidade = ': Sob Encomenda'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            } else {
              if (saldo.split(';')[1]) {
                this.disponibilidade =
                  ': Disponível em ' +
                  saldo.split(';')[0] +
                  '<br>' +
                  '(<strong>' +
                  saldo.split(';')[1].charAt(0).toUpperCase() +
                  saldo.split(';')[1].slice(1).toLowerCase() +
                  '</strong>)'
              } else {
                this.disponibilidade = ': Disponível em ' + saldo.split(';')[0]
              }

              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            }

            $(event.target).css('font-size', '12px')
          }
        }

        xhr.send(
          JSON.stringify({
            codigoProduto: this.product.code.split('-')[0],
            prdQtdeUnidade: 1,
          })
        )
      }
    },
    getPrecoComSt: function (event) {
      if (this.countPrecoComST == 0) {
        let xhr = new XMLHttpRequest()

        xhr.open('POST', this.$apiUrl + 'Produto.svc/getpreco/st')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.onload = () => {
          if (xhr.status == 200) {
            this.countPrecoComST++
            let preco = JSON.parse(xhr.responseText)
            if (preco == 0) {
              this.precoComSt = ': Produto não possui ST'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-price')
              $(event.target).css('font-weight', '700')
              $(event.target).css('font-size', '12px')
              $(event.target).css('height', '25px')
            } else if (this.formatPrice(this.product.price) !== this.formatPrice(preco) && preco > 0) {
              this.precoComSt = ': ' + this.formatPrice(preco) + ' à prazo com ST'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-price')
              $(event.target).css('font-weight', '700')
              $(event.target).css('font-size', '12px')
              $(event.target).css('height', '25px')
            } else {
              let xhrSimu = new XMLHttpRequest()

              xhrSimu.open('POST', this.$apiUrl + 'Produto.svc/getpreco/simulacao')
              xhrSimu.setRequestHeader('Content-type', 'application/json')
              xhrSimu.withCredentials = true

              xhrSimu.onload = () => {
                if (xhrSimu.status == 200) {
                  let precoSimulacao = JSON.parse(xhrSimu.responseText)

                  if (precoSimulacao > 0) {
                    this.precoComSt = ': Valor para simulação: ' + this.formatPrice(precoSimulacao)

                    $(event.target).removeClass('btn-light btn btn-xs')
                    $(event.target).addClass('product-price')

                    $(event.target).css('color', 'orange')
                    $(event.target).css('font-weight', '700')
                    $(event.target).css('font-weight', '700')
                    $(event.target).css('font-size', '12px')
                    $(event.target).css('height', '25px')
                    $(event.target).attr('title', 'Valor apenas para simulação, consulte seu contador')
                  } else {
                    this.precoComSt = ': Produto não possui ST'
                    $(event.target).removeClass('btn-light btn btn-xs')
                    $(event.target).addClass('product-price')
                    $(event.target).css('font-weight', '700')
                    $(event.target).css('font-size', '12px')
                    $(event.target).css('height', '25px')
                  }
                }
              }

              xhrSimu.send(
                JSON.stringify({
                  codigoProduto: this.product.code.split('-')[0],
                })
              )
            }
          }
        }

        xhr.send(
          JSON.stringify({
            codigoProduto: this.product.code.split('-')[0],
          })
        )
      }
    },
  },
}
</script>
